import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import { P, SectionHeading, SectionSubHeading, SectionWrapper } from "../../Styles/style";
import reflect from "../../../assets/images/reflect.png"
import commfoc from "../../../assets/images/commfoc.png"

const AboutImage = styled.img`
  width: 100%;
  height: auto;
  /* max-width: 80%; */
`;
const VideoBK = styled.video`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: auto;
`; const GridHEading = styled(Grid)`
/* padding: 50px 0; */
align-items: center;
place-content: ${(props) => (props.pc ? props.pc : "")};
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;
`;
const JOiningLinks = styled.img`
  /* width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "180PX")};
  @media screen and (max-width:599px){
   max-width: ${(props) => (props.mw ? props.mw : "140PX")};

 } */
`
const FeatureWrapper = styled.div`
 background: 
    linear-gradient(#000000 0 0) padding-box, /*this is your grey background*/
    linear-gradient(319deg, #000,#000,#000, #1765FF) border-box;
  border: 1px solid transparent;
backdrop-filter: blur(13px) !important;
  padding: 20px;
`
const S2_Aboutus = () => {
  return (
    <div>
      <SectionWrapper p="2rem 0 0" p799="0" p599="0" id="features">
        <Container maxWidth="xl">
          <GridHEading container spacing={3}>
            <SectionHeading
            p="30px 0"
            m="0"
            align="center"
            data-aos="flip-up"
            data-aos-easing="ease-in"
            data-aos-delay="400"
            data-aos-duration="400"
            data-aos-offset="0"
          >Features
          </SectionHeading>
            <GridImage item xs={12} md={6} 
            data-aos="fade-up" 
            data-aos-easing="ease-in"
            data-aos-delay="300"
            data-aos-duration="600"
            data-aos-offset="0"
            >
             <FeatureWrapper>
              <JOiningLinks src={reflect}   data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="500"
                data-aos-duration="600"
                data-aos-offset="0"/>
              <SectionSubHeading   
            data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="600"
                data-aos-duration="600"
                data-aos-offset="0">Reflection Token</SectionSubHeading>
             <P
                maxWidth="90%"
                p="0 0 40px 0"
                m="0"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="600"
                data-aos-offset="0"
              >
               At ArbFlow, we believe in creating a fair and equitable financial system for everyone. ArbFlow creates a level playing field where everyone can participate and benefit from the token's price action.</P>
             </FeatureWrapper>
              
           
            </GridImage>
            <GridImage item xs={12} md={6}  data-aos="fade-up" 
            data-aos-easing="ease-in"
            data-aos-delay="200"
            data-aos-duration="500"
            data-aos-offset="0">
             <FeatureWrapper>
              <JOiningLinks src={commfoc} data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="600"
                data-aos-offset="0"/>
              <SectionSubHeading data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="500"
                data-aos-duration="600"
                data-aos-offset="0">Community Focused</SectionSubHeading>
             <P
                maxWidth="90%"
                p="0 0 40px 0"
                m="0"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="600"
                data-aos-duration="600"
                data-aos-offset="0"
              >
               Our platform's community is a key structure. ArbFlow is committed to fostering a strong and supportive community by providing regular updates, engaging with our members, and responding to their feedback.</P> </FeatureWrapper>
              
           
            </GridImage>
          
          </GridHEading>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default S2_Aboutus;
